<script>
  import { Porthole } from '@client/components/porthole';

  import { nameFromEmail } from '@client/utils/users';

  export let row = {};
</script>

<div class="d-inline-flex gap-2 mt-1 align-items-center">
  {#key row.user}
    <Porthole
      details={{
        photoUrl: '',
        name: row.user,
        email: row.user
      }}
      size="small"
    />
    <div>
      <div class="bold">{nameFromEmail(row.user)}</div>
      <small class="text-muted">{row.user}</small>
    </div>
  {/key}
</div>
